/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/banner_templates/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplatesDuplicateCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdBannerTemplatesDuplicateProps,
  EngagementAppGroupIdBannerTemplatesDuplicateResult,
} from "./types";

export const postEngagementAppGroupIdBannerTemplatesDuplicate = reactQueryMutationAdapter(
  engagementAppGroupIdBannerTemplatesDuplicateCacheKeys,
  ({
    appGroupId,
    ids,
  }: PostEngagementAppGroupIdBannerTemplatesDuplicateProps): Promise<EngagementAppGroupIdBannerTemplatesDuplicateResult> => {
    return fetch(`/engagement/${appGroupId}/banner_templates/duplicate`, "POST", { ids }, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
